module.exports = __webpack_public_path__ + "img/logo-small.08166949.png";